import { render, staticRenderFns } from "./AiAssistantDrawer.vue?vue&type=template&id=184cc18e&scoped=true&"
import script from "./AiAssistantDrawer.vue?vue&type=script&lang=js&"
export * from "./AiAssistantDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AiAssistantDrawer.vue?vue&type=style&index=0&id=184cc18e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184cc18e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184cc18e')) {
      api.createRecord('184cc18e', component.options)
    } else {
      api.reload('184cc18e', component.options)
    }
    module.hot.accept("./AiAssistantDrawer.vue?vue&type=template&id=184cc18e&scoped=true&", function () {
      api.rerender('184cc18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalHeader/modal/AiAssistantDrawer/AiAssistantDrawer.vue"
export default component.exports